/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_clock': {
    width: 16,
    height: 16,
    viewBox: '0 0 14 14',
    data: '<g data-name="Group 3409"><path pid="0" data-name="Path 17832" d="M7 0a7 7 0 107 7 7 7 0 00-7-7zm3.026 8.331H7a.484.484 0 01-.484-.484V2.905a.484.484 0 11.968 0v4.458h2.542a.484.484 0 010 .968z" _fill="#959ba6"/></g>'
  }
})
